import { computed, inject } from "@angular/core";
import { signalStore, withComputed } from "@ngrx/signals";
import { GamesStore } from "./games.store";
import { AppsStore } from "./apps.store";
import { BackOfficeOfferViewModel } from "@playcharge/common/models/backend/offers/backoffice/backoffice-offer-view-model";

export type OffersStore = InstanceType<typeof OffersStore>;

export const OffersStore = signalStore(
    { providedIn: "root" },
    withComputed((_, gamesStore = inject(GamesStore), appsStore = inject(AppsStore)) => {
        const offers = computed(() =>
            gamesStore.entities().concat(appsStore.entities()).sort(sortFn),
        );
        const archivedOffers = computed(() =>
            gamesStore.archivedEntities().concat(appsStore.archivedEntities()).sort(sortFn),
        );

        return {
            offers,
            archivedOffers,
            allOffers: computed(() => offers().concat(archivedOffers()).sort(sortFn)),
        };
    }),
);

function sortFn(offer: BackOfficeOfferViewModel, other: BackOfficeOfferViewModel): number {
    return offer.affiseOfferId - other.affiseOfferId;
}
